var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play-pause_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play-pause_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.671 14.725c-.301.214-.613.234-.936.06a.86.86 0 01-.485-.808v-3.954a.86.86 0 01.485-.807c.323-.175.635-.155.936.059l2.837 1.977a.867.867 0 01.386.748.864.864 0 01-.386.748L6.67 14.725zM14 15.75a.724.724 0 01-.534-.216.725.725 0 01-.216-.534V9c0-.213.072-.39.216-.534A.726.726 0 0114 8.25c.213 0 .391.072.534.216A.725.725 0 0114.75 9v6c0 .213-.072.39-.216.534a.726.726 0 01-.534.216zm4 0a.724.724 0 01-.535-.216.725.725 0 01-.215-.534V9c0-.213.072-.39.216-.534A.726.726 0 0118 8.25c.213 0 .391.072.535.216A.725.725 0 0118.75 9v6c0 .213-.072.39-.216.534a.726.726 0 01-.534.216z"
  }))));
}
export default SvgPlayPause;